<template>
  <div>
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="navbar-header">
          <button type="button"
                  class="navbar-toggle navbar-toggle-black"
                  @click="toggleNavbar"
                  data-toggle="collapse"
                  data-target="#navigation-example-2">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar "></span>
            <span class="icon-bar "></span>
            <span class="icon-bar"></span>
          </button>
        </div>
        <div class="collapse navbar-collapse">
          <ul class="nav navbar-nav navbar-right">
            <li>
              <router-link to="/login" class="btn">
                Looking to login?
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <div class="wrapper wrapper-full-page">
      <div class="register-page">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-8 col-md-offset-2">
                <div class="header-text">
                  <img src="/static/img/ppe-locator-logo-main.png" alt="PPEs Locator" />
                  <h4>Account Created! Please provide your confirmation code.</h4>
                  <hr>
                </div>
              </div>
              <div class="col-md-4 col-md-offset-2">
                <div class="media">
                  <div class="media-left">
                    <div class="icon icon-success">
                      <i class="ti ti-check"></i>
                    </div>
                  </div>
                  <div class="media-body">
                    <h5>Check your phone!</h5>
                    A confirmation code should have been sent to your phone or email address. Please provide it here.
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <form method="#" action="#" @submit.prevent="confirmCode()">
                  <div class="card card-plain">
                    <div class="content">
                      <div class="form-group">
                        <input
                          type="text"
                          name="username"
                          v-model="model.username"
                          v-validate="modelValidations.username"
                          placeholder="Email Address"
                          class="form-control">
                        <small class="text-danger" v-show="username.invalid">
                          {{ getError('username') }}
                        </small>
                      </div>
                      <div class="form-group">
                        <input
                          type="text"
                          name="confirmation_code"
                          v-model="model.confirmation_code"
                          v-validate="modelValidations.confirmation_code"
                          placeholder="Confirmation Code"
                          class="form-control">
                        <small class="text-danger" v-show="confirmation_code.invalid">
                          {{ getError('confirmation_code') }}
                        </small>
                      </div>
                    </div>
                    <div class="footer text-center">
                      <button type="button" v-if="!loading" @click.prevent="confirmCode()" class="btn btn-fill btn-wd">Confirm</button>
                      <button type="button" v-if="loading" class="btn btn-wd" disabled="disabled">
                        <span class="btn-label">
                          <i class="fa fa-circle-o-notch fa-spin"></i>
                        </span>
                        Confirm!
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright text-center">
              Copyright &copy; 2020 Interdisciplinary Humanistic Technologies All rights reserved.
            </div>
          </div>
        </footer>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <li>
          <router-link to="/login">
            Looking to login?
          </router-link>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
import swal from 'sweetalert2'
import {mapFields} from 'vee-validate'

export default {
  computed: {
    ...mapFields(['username',
      'confirmation_code'])
  },
  data () {
    return {
      modelValidations: {
        username: {
          required: true
        },
        confirmation_code: {
          required: true
        }
      },
      loading: false,
      model: {
        username: '',
        confirmation_code: ''
      }
    }
  },

  methods: {
    toggleNavbar () {
      document.body.classList.toggle('nav-open')
    },
    closeMenu () {
      document.body.classList.remove('nav-open')
      document.body.classList.remove('off-canvas-sidebar')
    },
    confirmCode () {
      this.loading = true
      this.$cognitoAuth.confirmRegistration(this.model.username.toLowerCase(), this.model.confirmation_code, (err, result) => {
        if (err) {
          this.loading = false
          this.error = err
          console.error(err)
          swal({
            title: 'Error',
            text: err.message,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
        } else {
          swal({
            title: `Confirmed!`,
            text: 'Your account was confirmed!',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            type: 'success'
          }).then(() => {
            this.loading = false
            this.$router.replace('/login')
          })
        }
      })
    },
    beforeDestroy () {
      this.closeMenu()
    },
    getError (fieldName) {
      return this.errors.first(fieldName)
    }
  },

  mounted: function () {
    this.$nextTick(function () {
      if (this.$route.query.username) this.model.username = this.$route.query.username
    })
  }
}
</script>

<style>
.stripe-card {
  width: 300px;
  border: 1px solid grey;
}
.stripe-card.complete {
  border-color: green;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Confirm.vue